<template>
  <Tables ref="tableGrid"
          :columns="['CLIENTE', 'EMPREENDIMENTO', 'TORRE/ QUADRA', 'APARTAMENTO/ LOTE', 'IMOBILIÁRIA', 'CORRETOR', 'DT. DA VENDA', 'STATUS']"
          :showSearch="false"
          style="font-family:'Segoe UI'"
          :showPrint="false"
          :showDownload="false"
          :showFullscreen="false"
          v-on:Load="onLoad"
          >
              <tr v-for="request in requests" v-bind:key="request.id">
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit', request)" :status="1" :value="request.cliente.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit', request)" :status="1" :value="request.empreendimento.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit', request)" :status="1" :value="request.empreendimentoUnidade.grupo" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit', request)" :status="1" :value="request.empreendimentoUnidade.unidade" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit')" :status="1" :value="request.credenciada.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit', request)" :status="1" :value="request.conta.nome" />
                <TableColumn :IsText="true"   v-on:Edit="$emit('edit', request)" :status="1" :value="request.dataVendaFormatada" />
                <TableColumn :newState="true"  :colorStatus="request.colorStatus" :descriptionNewStatus="['Aprovado', 'Reprovado', 'Pendente', 'Pend. de Ajuste', 'Aprovado Pen.'][request.status]"  />
              </tr>
   </Tables>
</template>

<script>

import tableRequests from './tableRequests'
export default tableRequests

</script>

<style scoped>
.b-table-sticky-header, .table-responsive, [class*=table-responsive-] {
    margin-bottom: 100rem;
}

 @media screen and (max-width: 1600px) {
 .b-table-sticky-header, .table-responsive, [class*=table-responsive-] {
    margin-bottom: 3.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/requests/components/tableRequests/tableRequests.vue